export default __webpack_public_path__ + "static/media/skss.6177211b.png";